/** Source tag on `mrp.incoming_part` for forecast "ghost number" arrivals (not manual spreadsheet rows). */
export const MRP_GHOST_NUMBER_SOURCE = "Ghost number";

export function isMrpIncomingPartGhostSource(source: string | null | undefined): boolean {
  return (source?.trim().toLowerCase() ?? "") === MRP_GHOST_NUMBER_SOURCE.toLowerCase();
}

/** WHERE fragment for ghost-number rows (unqualified column names). */
export const SQL_WHERE_INCOMING_PART_GHOST_NUMBER =
  "lower(trim(coalesce(source, ''))) = 'ghost number'";
